import React from 'react';
import Card from '../../ui/Card';
const DealerHeatMap: React.FC = () => {
  const regionData = [{
    region: 'North',
    dealers: 145,
    performance: 92,
    color: 'bg-green-500'
  }, {
    region: 'West',
    dealers: 168,
    performance: 88,
    color: 'bg-green-400'
  }, {
    region: 'South',
    dealers: 132,
    performance: 78,
    color: 'bg-yellow-500'
  }, {
    region: 'East',
    dealers: 89,
    performance: 65,
    color: 'bg-orange-500'
  }];
  const getPerformanceColor = (performance: number) => {
    if (performance >= 85) return 'bg-green-500';
    if (performance >= 75) return 'bg-yellow-500';
    if (performance >= 65) return 'bg-orange-500';
    return 'bg-red-500';
  };
  return <Card className="p-6" data-id="element-7075">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-7076">
        Distributor/Dealer Performance by Region
      </h3>
      <div className="relative h-80 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-7077">
        <div className="grid grid-cols-2 gap-4 w-full max-w-md" data-id="element-7078">
          {regionData.map(region => <div key={region.region} className="p-6 bg-white border-2 border-gray-200 rounded-lg hover:shadow-lg transition-shadow" data-id="element-7079">
              <div className="flex items-center mb-3" data-id="element-7080">
                <div className={`w-4 h-4 rounded ${getPerformanceColor(region.performance)} mr-2`} data-id="element-7081" />
                <span className="font-medium text-gray-700" data-id="element-7082">
                  {region.region}
                </span>
              </div>
              <div className="space-y-2" data-id="element-7083">
                <div className="flex justify-between text-sm" data-id="element-7084">
                  <span className="text-gray-600" data-id="element-7085">Dealers</span>
                  <span className="font-semibold text-gray-800" data-id="element-7086">
                    {region.dealers}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-7087">
                  <span className="text-gray-600" data-id="element-7088">Performance</span>
                  <span className="font-semibold text-gray-800" data-id="element-7089">
                    {region.performance}%
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7090">
        <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-7091">
          <span data-id="element-7092">Performance: Sales vs Target Achievement</span>
          <div className="flex items-center space-x-3" data-id="element-7093">
            <div className="flex items-center" data-id="element-7094">
              <div className="w-3 h-3 rounded bg-green-500 mr-1" data-id="element-7095" />
              <span data-id="element-7096">85%+</span>
            </div>
            <div className="flex items-center" data-id="element-7097">
              <div className="w-3 h-3 rounded bg-yellow-500 mr-1" data-id="element-7098" />
              <span data-id="element-7099">75-85%</span>
            </div>
            <div className="flex items-center" data-id="element-7100">
              <div className="w-3 h-3 rounded bg-orange-500 mr-1" data-id="element-7101" />
              <span data-id="element-7102">&lt;75%</span>
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default DealerHeatMap;